// sockets/socket.js
import { io } from 'socket.io-client';

let socket = null;

export const initSocket = (tableId) => {
  socket = io(process.env.REACT_APP_EXPERIAN_SOCKET_DEV, {
    query: { tableId },
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    timeout: 20000,
  });

  return socket;
};

export const getSocket = () => socket;
